import { render, staticRenderFns } from "./DashboardCompras.vue?vue&type=template&id=2a682ae5&scoped=true&"
import script from "./DashboardCompras.vue?vue&type=script&lang=js&"
export * from "./DashboardCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a682ae5",
  null
  
)

export default component.exports